module.exports = __webpack_public_path__ + "static/header-image-06-2018-126bfa93cfed19fe81166b47cfce9b4b.png";